import { Stack } from '@mui/material';

import { Skeleton } from '@mui/material';

export const AnalyticCardSkeleton = () => {
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "flex-start",
        gap: 2
      }}>
      <Stack sx={{
        width: "100%"
      }}>
        <Skeleton variant="text" width="100%" height={35} />
        <Skeleton variant="text" width="75%" height={35} />
        <Skeleton variant="text" width="50%" height={35} />
        <Skeleton variant="text" width="30%" height={35} />
      </Stack>
    </Stack>
  );
};
